/**
 * ActivationPaymentsCustomSubscriptionCtrl controller
 */

import moment from 'moment'
import CheckUncheckDevices from './checkUncheckDevices.class'

/**
 * ActivationPaymentsCustomSubscriptionCtrl controller
 *
 * @class ActivationPaymentsCustomSubscriptionCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:ActivationPaymentsCustomSubscriptionCtrl
 */
/* @ngInject */
export default function ActivationPaymentsCustomSubscriptionCtrl ($scope, subscr, extra, scope) {
  var vm = this

  /**
   * Subscriber
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsCustomSubscriptionCtrl
   * @type {models.Subscriber}
   */
  vm.subscr = subscr

  /**
   * Extra
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsCustomSubscriptionCtrl
   * @type {Object}
   */
  vm.extra = extra

  /**
   * Shared scope
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsCustomSubscriptionCtrl
   * @type {Object}
   */
  vm.scope = scope

  /**
   * Return blank payment request
   * When user changes payment type, for exmple, we need new blank payment request, without old data
   *
   * @function
   */
  const getBlankPaymentRequest = (defaults = {}) => ({
    devicesToPay: null,
    length: 1,
    lengthType: 'Days',
    override: true,
    ...defaults
  })

  /**
   * Blank for PaymentRequest
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsCustomSubscriptionCtrl
   * @type {Object}
   */
  const payment = vm.payment = getBlankPaymentRequest()

  /**
   * Object with extra devices, which we want to include in CURRENT subscription, doing 'Add Devices' operation
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsCustomSubscriptionCtrl
   * @type {Object}
   */
  var includeDevicesOverride = vm.includeDevicesOverride = new CheckUncheckDevices()
  function updateIncludeDevicesOverride () {
    includeDevicesOverride.update(
      /* min */ extra.addDevicesInfoOverride.alreadyPaidDevices + 1,
      /* max */ Math.min(scope.devices.count(),
        extra.addDevicesInfoOverride.alreadyPaidDevices + extra.addDevicesInfoOverride.allowedDevicesToPay,
        scope.settings.ACTIVATION_DEVICE_LIMIT)
    ).includeFirst()
  }
  updateIncludeDevicesOverride()

  /**
   * Object with devices, which we want to include into the custom subscription
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsCustomSubscriptionCtrl
   * @type {Object}
   */
  var activatedDevices = vm.activatedDevices = new CheckUncheckDevices()
  function updateActivatedDevices () {
    activatedDevices.update(
      /* min */ 0,
      /* max */ Math.min(scope.devices.count() ? scope.devices.count() - 1 : scope.devices.count(), scope.settings.ACTIVATION_DEVICE_LIMIT)
    ).includeFirst()
  }

  updateActivatedDevices()

  // catch event from ActivationDevicesCtrl controller, when user adds or removes slots
  $scope.$parent.$on('event:deviceSlotsAmountChanged', function () {
    updateIncludeDevicesOverride()
    updateActivatedDevices()

    // if after we remove slots we cannot add custom subscription -> reset payment type
    if (!scope.can.Custom_Subscription()) {
      scope.change.paymentType()
    }
  })

  /**
  * Get length of custom subscription from selected date in calendar
  */
  const getDaysCount = () =>
    1 + Math.abs(moment(vm.dpCfg.minDate).diff(vm.dateOfExpiration, 'days'))

  /**
   * Use this fixed date instead of subscriber's expiration time, which could be null or in past
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsCustomSubscriptionCtrl
   * @type {moment}
   */
  vm.activeUntilFixed = subscr.expirationTime && subscr.expirationTime.isAfter()
    ? subscr.expirationTime
    : moment()

  /**
   * Get days count in human-readable format
   * @return {String} '1 day' or 'n days'
   */
  vm.getHumanDaysCount = function () {
    const c = vm.dateOfExpiration ? getDaysCount() : NaN
    if (c) {
      const lengthType = c === 1 ? ' day' : ' days'
      vm.changeSubscriptionLength(c, lengthType)
      return c + lengthType
    }
  }

  var last = vm.activeUntilFixed
  var now = moment()
  vm.dateOfExpirationFuture = new Date(last.year(), last.month(), last.date() + 1) // start of next day
  vm.dateOfExpirationTomorrow = new Date(now.year(), now.month(), now.date() + 1) // start of next day

  vm.dateOfExpiration = payment.override ? vm.dateOfExpirationTomorrow : vm.dateOfExpirationFuture
  vm.dpCfg = {
    minDate: vm.dateOfExpiration,
    format: 'dd.MM.yyyy',
    opened: false,
    changeHandler: function (form) {
      const interval = vm.dateOfExpiration && vm.dpCfg.minDate <= vm.dateOfExpiration
      const maxDays = !scope.settings.ACTIVATION_LENGTH_LIMIT || (getDaysCount() <= scope.settings.ACTIVATION_LENGTH_LIMIT)

      form.pexpdate.$setValidity('interval', interval)

      form.pexpdate.$setValidity('maxDays', maxDays)

      return !interval || !maxDays
    }
  }
  vm.openDOE = function () {
    vm.dpCfg.opened = true
  }

  /*
   * Get part of payment from child view
   */
  scope.getChildPayment = (forProcessing) =>
    forProcessing
      ? {
        ...payment,
        devicesToPay: activatedDevices.count(),
        length: vm.lengthType === 'c' ? getDaysCount() : payment.length,
        lengthType: vm.lengthType === 'c' ? 'Days' : payment.lengthType,
        subscriptionId: vm.subscription && vm.subscription.id
      }
      : undefined

  vm.changeDevices = function (n) {
    vm.activatedDevices.change(n)
    scope.countCustomSubscriptionDevices(activatedDevices.count())
  }

  vm.changeSubscription = function () {
    scope.customSubscription = vm.subscription
    scope.change.mainSubscription(vm.subscription)
    scope.calculate()
  }

  vm.changeSubscriptionLength = function (length, lengthType) {
    if (vm.lengthType === 'c') {
      scope.countCustomSubscriptionLength({ length, lengthType })
    }
    if (vm.lengthType === 'l' && vm.payment.length) {
      scope.countCustomSubscriptionLength({ length: vm.payment.length, lengthType: vm.payment.lengthType })
    }
  }

  vm.addDevice = function () {
    activatedDevices.update(
      /* min */ 0,
      /* max */ Math.min(activatedDevices.max + 1, scope.settings.ACTIVATION_DEVICE_LIMIT)
    ).includeAll()
  }
  vm.deleteDevice = function () {
    activatedDevices.update(
      /* min */ 0,
      /* max */ Math.min(activatedDevices.max - 1, scope.settings.ACTIVATION_DEVICE_LIMIT)
    )
  }
}
